import {XauditModel} from '../xaudit.model';

export class DataARCreditDebitReasonModel extends XauditModel{

  CreditDebitReasonID: string;
  LOCID: number;
  enumCreditDebitTypeID: string;
  ItemOrder: number;
  enumARReasonCreditAdjustmentID: string;
  enumARReasonDebitAdjustmentID: string;
  Reason: string;
  isExcludeFromAdjRec: boolean;
}
